import { effect, inject } from "@angular/core";
import { patchState, signalStore, withComputed, withHooks, withMethods, withProps, withState } from "@ngrx/signals";
import { LoginStore } from "../../../stores/login.store";
import { StateStore } from "../../../services/state/state.store";

interface SeProfileUiState {
    currentContactId: number | undefined;
    profileImageValue: string | undefined;
}

const initialState: SeProfileUiState = {
    currentContactId: undefined,
    profileImageValue: undefined,
};

export const SeProfileUiStore = signalStore(
    { providedIn: "root" },
    withState(initialState),
    withProps(() => ({
        _loginStore: inject(LoginStore),
        _stateStore: inject(StateStore),
    })),
    withComputed((store) => ({
        isSeActive: () => store._stateStore.isStudentEngagementState(),
        hasProfileImageOverride: () => !!store.profileImageValue(),
    })),
    withMethods((store) => ({
        setContactProfileImage: (contactId: number, value: string | undefined) => {
            patchState(store, {
                currentContactId: contactId,
                profileImageValue: value || undefined,
            });
        },
        clearProfileImage: () => {
            patchState(store, initialState);
        },
    })),
    withHooks({
        onInit: (store) => {
            effect(() => {
                const loggedIn = store._loginStore.loggedIn();
                const seActive = store.isSeActive();
                if (!loggedIn || !seActive) {
                    store.clearProfileImage();
                }
            });
        },
    }),
);

export type SeProfileUiStore = InstanceType<typeof SeProfileUiStore>;
